<template>
	<v-dialog v-model="dialog" max-width="400px">
		<v-card>
			<v-app-bar dense dark flat color="primary">
				<v-app-bar-title class="color-white">新規車種追加</v-app-bar-title>
				<v-spacer />
				<v-btn icon dark @click="dialog = false" color="white">
					<v-icon>mdi-close</v-icon>
				</v-btn>
			</v-app-bar>
			<v-card-text class="pa-2">
				<v-form ref="form" lazy-validation class="d-flex justify-center">
					<v-text-field
						v-model="newCarModelName"
						class="mt-4"
						style="width: 100%"
						label="車種"
						outlined
						dense
					/>
					<v-btn
						class="ma-2 pa-2 mt-4"
						:disabled="!newCarModelName"
						color="primary"
						@click="addCarModel()"
						>追加</v-btn
					>
				</v-form>
			</v-card-text>
			<v-card-actions>
				<v-row no-gutters> </v-row>
			</v-card-actions>
		</v-card>
	</v-dialog>
</template>

<script>
import moment from "moment"
import axios from "axios"
import authenticate from "../../../helper/authenticate"
import errorHandling from "../../../helper/errorHandling"
import common from "../../../helper/common"
import rules from "../../../helper/rules"
import FunctionTitle from "../../shared/FunctionTitle.vue"
import CommonFlame from "../../shared/CommonFlame.vue"

export default {
	props: {
		text: {
			type: Boolean,
			required: false,
			default: false,
		},
	},
	data() {
		return {
			dialog: false,
			newCarModelName: "",
		}
	},
	methods: {
		openDialog() {
			this.dialog = true
		},
		addCarModel() {
			const headers = authenticate.setHeader()
			var formData = new FormData()
			formData.set("new_car_model", this.newCarModelName)
			axios
				.post("/erp/v1/car_models", formData, { headers })
				.then((res) => {
					this.$emit("pushName", res.data.new_car_model.name)
					this.newCarModelName = ""
					this.dialog = false
				})
				.catch((err) => {
					errorHandling.errorResponse(err)
				})
		},
	},
	computed: {},
}
</script>

<style lang="scss" scoped>
.v-input--selection-controls {
	margin-top: 0;
}
</style>
